// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"81b5cecc","56":"09071001","311":"2af8a3b4","336":"b693cc4a","380":"b58890ad","384":"1f6daf10","392":"ba39d36c","417":"d0f135fd","665":"c1239090","895":"2348a9e4","912":"5ce786ec"}[chunkId] + ".chunk.js";
};